var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isOutlook
      ? _c("div", [
          _c(
            "div",
            {
              staticClass: "form-group",
              class: { "has-error": _vm.errors.has("comment") }
            },
            [
              _c(
                "label",
                {
                  staticClass: "col-sm-2 control-label",
                  attrs: { for: "comment" }
                },
                [_vm._v("Description of Services:")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-10 col-md-8 col-lg-6" }, [
                _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate.disable",
                      value: "required",
                      expression: "'required'",
                      modifiers: { disable: true }
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.timeEntry.comment,
                      expression: "timeEntry.comment"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    "data-vv-as": "Re",
                    type: "text",
                    id: "comment",
                    name: "comment",
                    placeholder: "Summary (100 characters max)",
                    maxlength: "100",
                    autocomplete: "on"
                  },
                  domProps: { value: _vm.timeEntry.comment },
                  on: {
                    keyup: _vm.commentCheck,
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.timeEntry, "comment", $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _vm.errors.has("comment")
                  ? _c("p", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.errors.first("comment")))
                    ])
                  : _vm._e()
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c(
              "label",
              {
                staticClass: "col-sm-2 control-label",
                attrs: { for: "noteText" }
              },
              [_vm._v("Content:")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-10 col-md-8" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.timeEntry.noteText,
                    expression: "timeEntry.noteText"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  rows: "3",
                  id: "noteText",
                  name: "noteText",
                  readonly: _vm.isOutlook,
                  placeholder: "What happened? (detailed)"
                },
                domProps: { value: _vm.timeEntry.noteText },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.timeEntry, "noteText", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _vm.errors.has("noteText")
                ? _c("p", { staticClass: "text-danger" }, [
                    _vm._v(_vm._s(_vm.errors.first("noteText")))
                  ])
                : _vm._e()
            ])
          ])
        ])
      : _c(
          "div",
          {
            staticClass: "form-group",
            class: { "has-error": _vm.errors.has("noteText") }
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-10 col-md-8" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.timeEntry.noteText,
                    expression: "timeEntry.noteText"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  rows: "4",
                  id: "noteText",
                  name: "noteText",
                  placeholder: "Summary followed by detailed comment"
                },
                domProps: { value: _vm.timeEntry.noteText },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.timeEntry, "noteText", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _vm.errors.has("noteText")
                ? _c("p", { staticClass: "text-danger" }, [
                    _vm._v(_vm._s(_vm.errors.first("noteText")))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "small",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.timeEntry.isLegacyTEEntry,
                      expression: "timeEntry.isLegacyTEEntry"
                    }
                  ],
                  staticClass: "text-warning"
                },
                [
                  _vm._v(
                    "RE/Comment have been combined. Review and ensure the Description of Services appears as intended."
                  )
                ]
              )
            ])
          ]
        )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-2 control-label" }, [
      _c("label", { attrs: { for: "noteText" } }, [
        _vm._v("Description of Services:")
      ]),
      _vm._v(" "),
      _c("div", [
        _c("small", { staticClass: "text-muted" }, [
          _vm._v("First 400 characters"),
          _c("br"),
          _vm._v("appear on invoice")
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cd39d692", { render: render, staticRenderFns: staticRenderFns })
  }
}